import { Box, Card, Divider } from '@zillow/constellation-10';

import AddPhotosFormField from '../../AddPhotos/components/PhotoUploadFormField';
import AmenitiesWithAdditionalAmenitiesFields from '../../AmenitiesProperty/components/AmenitiesWithAdditionalAmenitiesFields';
import PropertyDescriptionFormField from '../../DescribeProperty/components/PropertyDescriptionFormField';
import { default as FinancialExpectationsFormSectionContainer } from '../../FinancialExpectations/components/FormSectionContainer';
import { default as LeaseTermsFormSectionContainer } from '../../LeaseTerms/components/FormSectionContainer';
import PetsAllowedFormField from '../../PetPolicyAndPetFee/components/PetsAllowedFormField';

import { WizardBody, WizardHeading } from '../../../../styles/wizard';

const FormSectionContainer = () => {
  return (
    <Box data-testid="FormSectionContainer-MultiplexPropertyDetails">
      <WizardHeading textStyle="heading-sm" level={1}>
        Property details
      </WizardHeading>

      <WizardBody>
        These details apply to all units by default. You can adjust or add to these for individual units later. This
        step is optional — you can skip it.
      </WizardBody>

      {/* form fields */}
      <Card>
        <Box data-testid="SectionContainer-AddPhotos">
          <WizardHeading textStyle="heading-sm" level={2}>
            Photos
          </WizardHeading>
          <WizardBody>Photos help renters imagine living in your place</WizardBody>

          <AddPhotosFormField />
        </Box>

        <Divider css={{ marginBlock: '400' }} />

        <Box data-testid="SectionContainer-PropertyDescription">
          <WizardHeading textStyle="heading-sm" level={2}>
            Description
          </WizardHeading>

          <PropertyDescriptionFormField />
        </Box>

        <Divider css={{ marginBlock: '400' }} />

        <Box data-testid="SectionContainer-FinancialExpectations">
          <WizardHeading textStyle="heading-sm" level={2}>
            Financial expectations
          </WizardHeading>

          <FinancialExpectationsFormSectionContainer />
        </Box>

        <Divider css={{ marginBlock: '400' }} />

        <Box data-testid="SectionContainer-PetsAllowed">
          <WizardHeading textStyle="heading-sm" level={2}>
            Pets
          </WizardHeading>

          <PetsAllowedFormField />
        </Box>

        <Divider css={{ marginBlock: '400' }} />

        <Box data-testid="SectionContainer-LeaseTerms">
          <WizardHeading textStyle="heading-sm" level={2}>
            Lease terms
          </WizardHeading>

          <LeaseTermsFormSectionContainer />
        </Box>

        <Divider css={{ marginBlock: '400' }} />

        <Box data-testid="SectionContainer-Amenities">
          <WizardHeading textStyle="heading-sm" level={2}>
            Amenities
          </WizardHeading>

          <WizardBody>Sharing more will help renters see themselves in your home</WizardBody>

          <AmenitiesWithAdditionalAmenitiesFields />
        </Box>
      </Card>
    </Box>
  );
};

export default FormSectionContainer;
